import React, { useEffect, lazy } from "react";
import axios from "axios";

import Navbardesign from "../Components/Navbar";
import BannerSwiper from "../Components/Bannerdesign/Bannerdesign";
import ProjectSection from "../Components/Projectcard/Projectdesign";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";
import BlogDetail from "../Components/Blogspagecomponents/BlogssepartedcardInduzuval";

/* ---------------- LAZY LOAD ---------------- */
const Testimonials = lazy(
  () => import("../Components/Testimonalprocess/Testimonalsprocess"),
);

/* ---------------- API BASE ---------------- */
const API_BASE = "https://mithahomes.com/backend/api";
const VIEW_API = `${API_BASE}/apiviewcount`;

/* ---------------- COMPONENT ---------------- */
const BlogsDetailsProcessSepretedidMantained = () => {
  /* ===============================
     SCROLL TO TOP
  ================================ */
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  /* ===============================
     VIEW COUNT + ACTIVE USER
  ================================ */
  useEffect(() => {
    const trackActiveUser = async () => {
      try {
        await axios.post(`${VIEW_API}/active`);
      } catch (err) {
        console.error("Active user tracking failed");
      }
    };

    const increaseViewCount = async () => {
      try {
        await axios.post(`${VIEW_API}/view`);
      } catch (err) {
        console.error("View count update failed");
      }
    };

    trackActiveUser();
    increaseViewCount();
  }, []);

  return (
    <>
      {/* ================= PAGE CONTENT ================= */}
      <Navbardesign />

      <br />
      <br />
      <br />

      <BlogDetail />

      {/* ---------- FOOTER ---------- */}
      <Footer />

      {/* ---------- CONTACT BAR GAP ---------- */}
      <div style={{ height: "90px" }} />
      <ContactBar />
    </>
  );
};

export default BlogsDetailsProcessSepretedidMantained;
